
import React from 'react'
import { RelatedProductsList } from './RelatedProductsList'

import './related_products.scss'

const formatProductList = (values = []) => {
  return values.map(value => {
    const { field_product_images } = value.relationships
    if (!field_product_images) {
      return false
    }

    const [image] = field_product_images.map(image => image.relationships.field_media_image_2.gatsbyImage)

    return {
      id: value.id,
      title: value.title,
      path: value.path.alias,
      image: image
    }
  }).filter(result => result)
}

export const RelatedProducts = ({ field_related_products }) => {
  if (!field_related_products) return <></>
  return <RelatedProductsList items={formatProductList(field_related_products)} />
}
